import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IDetails_Response } from '@shared/constants/models.const';
import { ThreeColumnTemplateComponent } from '@templates/three-column-template/three-column-template.component';
import { E_CONTENT_TYPE, E_FOLDER_TYPES } from '@shared/constants/enums.const';
import { CkViewerComponent } from '@shared/components/ck-viewer/ck-viewer.component';
import { SideNavigationComponent } from '@shared/components/side-navigation/side-navigation.component';
import { LinksSectionComponent } from '@shared/components/links-section/links-section.component';
import { TranslateModule } from '@ngx-translate/core';
import { HorizontalDividerComponent } from '@shared/components/horizontal-divider/horizontal-divider.component';
import { BreadcrumbsComponent } from '@shared/components/breadcrumbs/breadcrumbs.component';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { TocComponent } from '@shared/components/toc/toc.component';
import { NewsSectionComponent } from '../home/components/news-section/news-section.component';
import { SeeAllComponent } from '@shared/components/see-all/see-all.component';
import { DefaultPortletsComponent } from '@shared/components/default-portlets/default-portlets.component';
import { CollectionsComponent } from '@shared/components/collections/collections.component';

@Component({
  selector: 'app-resources-list',
  imports: [
    ThreeColumnTemplateComponent,
    CkViewerComponent,
    SideNavigationComponent,
    LinksSectionComponent,
    TranslateModule,
    HorizontalDividerComponent,
    BreadcrumbsComponent,
    TocComponent,
    NewsSectionComponent,
    SeeAllComponent,
    DefaultPortletsComponent,
    CollectionsComponent,
  ],
  templateUrl: './resources-list.component.html',
  styleUrl: './resources-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourcesListComponent {
  pageData = input<IDetails_Response | any>();
  protected readonly E_FOLDER_TYPES = E_FOLDER_TYPES;
  protected readonly E_CONTENT_TYPE = E_CONTENT_TYPE;
  protected readonly ButtonTypes = BUTTON_TYPES;
}
